import React from 'react';
import { Link } from 'react-router-dom';

const Hero = ({ article }) => {
  if (!article) return null;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-AU', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <section className="relative h-[500px] md:h-[600px] lg:h-[700px] overflow-hidden">
      {/* Background Image with Overlay */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${article.image_url || 'https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=1600&h=900&fit=crop'})`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-neutral-900 via-neutral-800/90 to-neutral-900/70" />
      </div>

      {/* Content */}
      <div className="relative h-full flex items-end">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12 md:pb-16 w-full">
          <div className="max-w-3xl">
            {/* Category Badge */}
            <span className="inline-block px-4 py-2 bg-primary-600 text-white text-sm font-semibold rounded-full mb-4">
              {article.category?.[0]?.toUpperCase() || 'NEWS'}
            </span>

            {/* Title */}
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight">
              {article.title}
            </h1>

            {/* Description */}
            <p className="text-lg md:text-xl text-neutral-200 mb-6 leading-relaxed line-clamp-3">
              {article.description}
            </p>

            {/* Meta Info */}
            <div className="flex items-center text-neutral-300 text-sm mb-6">
              <span>{formatDate(article.pubDate)}</span>
              {article.creator && article.creator.length > 0 && (
                <>
                  <span className="mx-2">•</span>
                  <span>{article.creator[0]}</span>
                </>
              )}
            </div>

            {/* CTA Button */}
            <Link
              to={`/article/${article.article_id}`}
              className="inline-block bg-primary-600 hover:bg-primary-700 text-white font-semibold px-8 py-4 rounded-lg transition-colors duration-200 text-lg"
            >
              Read More
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
